export var CompanyUserRoles;
(function (CompanyUserRoles) {
    CompanyUserRoles["CompanyUser"] = "CompanyUser";
    CompanyUserRoles["SuperUser"] = "SuperUser";
    CompanyUserRoles["Orderer"] = "Orderer";
})(CompanyUserRoles || (CompanyUserRoles = {}));
